import React from "react";
import { Box, BoxProps, TableCell, TableRow } from "@material-ui/core";
import styled from "styled-components";
import { transition } from "styles/utils";

export const MaterialSpecTableRow = styled(TableRow)`
    & > * {
        border-bottom: unset;
    }
`;

export const MaterialSpecTableRowHeader = styled(TableRow)`
    th {
        font-weight: ${({ theme }) => `${theme.typography.fontWeightBold}`};
        color: white;
        background-color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const MaterialSpecsCards = styled(TableCell)`
    position: relative;
    padding-bottom: 0;
    padding-top: 0;
`;

export const MaterialSpecRowBox = styled(({ open, ...props }: BoxProps & { open: boolean }) => <Box {...props} />)`
    cursor: pointer;
    background-color: ${({ open, theme }) => (open ? theme.palette.secondary[100] : "white")}};
    
    :hover {
        background-color: ${({ theme }) => theme.palette.secondary[200]}
    }
    
    {${transition(0.3)}
`;

export const MaterialSpecRowDetailsBox = styled(({ ...props }: BoxProps) => <Box {...props} />)`
    background-color: ${({ theme }) => theme.palette.secondary[100]};
`;
